export const recordingStartEvent = "<&-R <b9g> <?9ay1^v> <lO3t> <ary4Zp>/>";
export const recordingEndEvent = "<&-R <b9g> <^v^> <aObn> <eNp0bqr>/>";